module.exports = __webpack_public_path__ + "img/karmare-interior.77e7a730.jpg";